import React from 'react'
import { VoicePreviewButton } from './voice-preview-button'
import type { VoiceOption } from '../../context/podcast-editor-provider'
import { cn } from '../../../../lib/utils'
import { Tooltip } from '../../../../components/ui/tooltip'

export const VoiceOptionItem: React.FC<{
  optionId: string
  meta?: VoiceOption
  isPlaying: boolean
  onToggle: (e: React.MouseEvent, id: string, url?: string | null) => void
}> = ({ optionId, meta, isPlaying, onToggle }) => (
  <div className="flex w-full items-center gap-3">
    {meta?.previewUrl ? (
      <VoicePreviewButton isPlaying={isPlaying} onClick={(e) => onToggle(e, optionId, meta.previewUrl)} />
    ) : (
      <span className="shrink-0 inline-flex h-7 w-7" aria-hidden />
    )}
    <div className="min-w-0 flex-1">
      <div className="flex flex-col gap-0.5 truncate">
        <div className="flex items-center justify-between gap-2">
          <span className={cn("font-medium truncate", isPlaying && "text-brand-500")}>
            {meta?.name || 'Unknown Voice'}
          </span>
          <div className="flex items-center gap-1 shrink-0">
            {(meta?.isDefaultA || meta?.isDefaultB) && (
              <span className="rounded-full border border-black/10 bg-foreground/[0.04] px-2 py-0.5 text-[10px] font-medium text-foreground/70">
                Default
              </span>
            )}
            {meta?.category && (
              <span className={cn(
                "text-[10px] px-1.5 py-0.5 rounded-full font-medium border",
                meta.category === 'Stable' && "bg-blue-50 text-blue-700 border-blue-200",
                meta.category === 'Emotive' && "bg-purple-50 text-purple-700 border-purple-200",
                meta.category === 'Narration' && "bg-amber-50 text-amber-700 border-amber-200",
                meta.category === 'General' && "bg-gray-50 text-gray-600 border-gray-200"
              )}>
                {meta.category}
              </span>
            )}
            {meta?.gender && (
              <Tooltip content={meta.gender} className="capitalize">
                <span
                  className="text-base cursor-default px-1"
                  aria-label={meta.gender}
                >
                  {(() => {
                    const g = meta.gender.toLowerCase()
                    if (g === 'masculine' || g === 'male') return '👨'
                    if (g === 'feminine' || g === 'female') return '👩'
                    return '🧑'
                  })()}
                </span>
              </Tooltip>
            )}
          </div>
        </div>
        <div className="flex items-center gap-2 text-xs text-muted-foreground truncate">
          {meta?.description && (
            <span className="truncate">{meta.description}</span>
          )}
        </div>
      </div>
    </div>
  </div>
)
